module.exports = __webpack_public_path__ + "static/finalist seal_NSW_Best Customer Service-534eb6b3603fc0e03a6a5676b3c43024.png";